// connect CSS
require('./assets/css/allCSS.min.css')

// connect JS
require('./assets/jscript/jquery.min.js')
require('./assets/jscript/scrolloverflow.min.js')
require('./assets/jscript/jquery.fullpage.min.js')



import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './lang/lang'
import store from './store'
import params from '../public/site_config.json'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.config.productionTip = false;

Vue.mixin({
	data: function() {
		return {
			needLoader: true,
			curLocaleAlias: '',
			curLocaleName: '',
            automation: 0
		}
	},
	methods: {
        switchLang: function(lang){
            $('body').removeClass('faderOut').addClass('faderIn');

            let _this = this;
            setTimeout(function() {
                _this.doSwitchLang(lang);
            }, 400);
        },
        doSwitchLang: function(lang) {
            if (lang in vue.$i18n.messages) {
                this.$i18n.locale = lang
            } else {
                this.loadLocaleMessage(lang, (err, message) => {
                    if (err) {
                        console.error(err)
                        return
                    }
                    i18n.setLocaleMessage(lang, message)
                    this.$i18n.locale = lang
                })
            }

            this.curLocaleAlias = (lang == params.initial_lang)? '' : '/'+lang
            this.curLocaleName = (lang == params.initial_lang)? '' : lang+'.'
            
            let routeName = this.$route.name,
                routeNameParts = routeName.split('.'),
                routerLocale = (lang == params.initial_lang)? '' : lang+'.';

            routeName = routerLocale + ((routeNameParts.length == 2)? routeNameParts[1] : routeNameParts[0])
            router.push({name: routeName, params: { locale: lang }});

            setTimeout(function() {
                $.fn.fullpage.reBuild();
                $('body').addClass('faderOut');
            }, 400);
        },
        setLangNew: function(lang){
            this.$store.dispatch('setLangNew', lang)
        },
        setLang: function(lang){
            this.$store.dispatch('setLang', lang)
        },
        loadLocaleMessage: function(locale, cb) {
            return fetch(`./src/lang/${locale}.json` , {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                return res.json()
            }).then((json) => {
                if (Object.keys(json).length === 0) {
                    return Promise.reject(new Error('locale empty !!'))
                } else {
                    return Promise.resolve(json)
                }
            }).then((message) => {
                cb(null, message)
            }).catch((error) => {
                cb(error)
            })
        },
        updateMixins: function() {
            var path = this.$route.name.split('.');
            
            if(path[0] == 'en' || path[0] == 'ru' || path[0] == 'ua') {
                i18n.locale = path[0]
                this.curLocaleAlias = (path[0] == params.initial_lang)? '' : '/'+path[0]
                this.curLocaleName = (path[0] == params.initial_lang)? '' : path[0]+'.'
            }
        },
        runAll: function() {
            let _this = this;
            var changeDelay = ($(window).width() <= 1024)? 0 : 500;
            
            setTimeout(function() {
                $('body, .fp-section.active, .fp-slide.active').addClass('startAnim');
                $('.preloader_box').remove();
                setTimeout(function() {
                    $('body, .fp-completely, .fp-slide.active').addClass('startAnimBtns');
                    if($('body').hasClass('fp-responsive')) {
                        $('body, .fp-section.active, .fp-slide.active').addClass('startAnimBtns');
                    }
                }, 500);
            }, changeDelay);
            
            if($('body').hasClass('fp-responsive')) {
                $('.fp-section.active').prevAll().addClass('startAnim startAnimBtns');
            }
        },
        actWithViewport: function() {
            let _this = this,
                enterPoint = Math.round($(window).height() * .7);
            
            $('.automation__item').each(function() {
                if($(this).position().top <= enterPoint) {
                    $(this).addClass('visible_anim');
                }
            });
        },
        scrollDetect: function(pos) {
            if(pos > 0) {$('body').addClass('lightBack');}
            
            $('.blackBack').each(function() {
                var ofTop = $(this).offset().top,
                    ofBot = ofTop + $(this).outerHeight();
                    
                if(pos+30 > ofTop && pos+30 < ofBot) {
                    if(ofTop <= pos+30 && ofBot >= pos+30 && $('body').hasClass('lightBack')) {$('body').removeClass('lightBack');}
                }
            });
        },
        checkVisibilities: function() {
            $('.detectMobVisibility').each(function() {
                if(!$(this).hasClass('thisVisible')) {
                    if($(this).offset().top < Math.round($(window).scrollTop() + $(window).height() * .9)) {
                        $(this).addClass('thisVisible');
                    }
                }
                else {
                    if($(this).offset().top > Math.round($(window).scrollTop() + $(window).height())) {
                        $(this).removeClass('thisVisible');
                    }
                }
            });
        }
    },
    mounted() {
		var _this = this;
		
        $('.startAnim').removeClass('startAnim');
		if(!this.$cookies.isKey("preloader")) {
			setTimeout(function() {
				$('.preloader_box').addClass('startLoader');
				setTimeout(function() {
					$('.preloader_box').addClass('startLoad');
				}, 400);
				
				setTimeout(function() {
					_this.$cookies.set("preloader","/","1d");
					$('.preloader_box').addClass('endLoader');
					setTimeout(function() {
                        setTimeout(function() {_this.runAll();}, 500);
					}, 500);
				}, 3400);
			}, 500);
		}
		else {
            $('.preloader_box').remove();
            setTimeout(function() {_this.runAll();}, 500);
        }
        
        // mobile scroll visibility
        if($(window).width() < 1024) {
            setTimeout(function() {
                _this.checkVisibilities();
            }, 200);
            
            var checkTimer = 0,
                savePosition = 0;
            $(window).scroll(function(e) {
                clearTimeout(checkTimer);
                
                checkTimer = setTimeout(function() {
                    _this.checkVisibilities();
                }, 30);
            });
        }
        else {$('.detectMobVisibility').removeClass('thisVisible');}
		
        this.updateMixins()
    },
    beforeRouteLeave (to, from, next) {
        next(false);

        $('body').removeClass('faderIn faderOut').addClass('faderIn');

        setTimeout(function() {
            next();
        }, 550);
    },
    beforeRouteEnter (to, from, next) {
        next()
        
        setTimeout(function() {
            $('body').removeClass('faderIn faderOut').addClass('faderOut');
        }, 550);
    }
})





export const app = new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app');

window['vue'] = app
window.store = store